<template>
  <div>
    <v-card-title>
      <h3 class="headline my-0">{{ $t('Datos del Alta') }}</h3>
    </v-card-title>
    <v-divider light></v-divider>
    <v-card-text>
      <tipo-de-contrato v-model="formData" :disabled="disabled"></tipo-de-contrato>
      <formacion-y-categoria-profesional
        v-model="formData"
        :disabled="disabled"
      ></formacion-y-categoria-profesional>
      <remuneracion v-model="formData" :disabled="disabled"></remuneracion>
      <jornada-laboral v-model="formData" :disabled="disabled"></jornada-laboral>
      <periodo-de-prueba v-model="formData" :disabled="disabled"></periodo-de-prueba>
    </v-card-text>
  </div>
</template>

<script>
import TipoDeContrato from './laboral-inputs/TipoDeContrato.vue';
import Remuneracion from './laboral-inputs/Remuneracion.vue';
import JornadaLaboral from './laboral-inputs/JornadaLaboral.vue';
import FormacionYCategoriaProfesional from './laboral-inputs/FormacionYCategoriaProfesional.vue';
import PeriodoDePrueba from '@/modules/laboral/components/forms/laboral-requests/partials/laboral-inputs/PeriodoDePrueba.vue';

export default {
  components: {
    TipoDeContrato,
    Remuneracion,
    JornadaLaboral,
    FormacionYCategoriaProfesional,
    PeriodoDePrueba,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          tipo_de_contrato: null,
          obra_y_servicio: {},
          eventual: {},
          indefinido_fijo_discontinuo: {},
          practicas_curriculares: {},
          sustitucion: {},
          titulacion: null,
          categoria_profesional: null,
          jornada_laboral: null,
          jornada_laboral_horas_semanales: null,
          jornada_laboral_horario: null,
          descripcion_puesto_trabajo: null,
          periodo_de_prueba: null,
          plazo_periodo_de_prueba: null,
        };
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
